





















import Vue from 'vue';
import { mapGetters } from 'vuex';
import { ShoriKb } from '@/constants/constants';
import { isShorikbADD } from '@/utils/utils';
export default Vue.extend({
  name: 'CtrlMstMenteToolBar',
  props: {
    mainTitle: {
      type: String,
      default: '',
    },
    checkTime: {
      type: String,
      default: '',
    },
    shoriKb: {
      type: Number,
      default: ShoriKb.ADD,
    },
  },
  computed: {
    ...mapGetters({
      childHeaderTitle: 'common/childHeaderTitle',
    }),
  },
  methods: {
    isShorikbADD,
  },
  created() {
    this.$store.dispatch('common/getChildHeaderTitle', {
      shoriKb: this.shoriKb,
    });
  },
});
